import Tab from "./Tab";
import TabList from "./TabList";
import TabPanel from "./TabPanel";
import Tabs from "./Tabs";

export default { Tab, TabList, TabPanel, Tabs };
export { Tab, TabList, TabPanel, Tabs };
